export default __webpack_public_path__ + "static/media/image-chair-algo-lima-04-l-w@2x.9f6a2849.png";